import api, { adminApiPrefix } from './Api';
import { MetaTable } from '../interfaces/Meta/MetaTable';
import {
  Meta,
  metaFromResponse,
  metaToUpsertRequest,
} from '../interfaces/Meta/Meta';

const metaAdminApiPrefix = `${adminApiPrefix}/meta`;

export const getMeta = async (table: MetaTable, id: number): Promise<Meta> => {
  const response = await api.get(`${metaAdminApiPrefix}/${table}/${id}`);

  return metaFromResponse(response.data?.data);
};

export const updateMeta = async (
  table: MetaTable,
  id: number,
  meta: Meta,
): Promise<Meta> => {
  const response = await api.put(
    `${metaAdminApiPrefix}/${table}/${id}`,
    metaToUpsertRequest(meta),
  );

  return metaFromResponse(response.data?.data);
};
